import React, { Component } from 'react';
import withScrollbar from '../Extensions/WithScrollbar';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';

class CNVDRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMSF: false,
      scannedFileIds: [],
    };
    this.handleComponentFileModal = this.handleComponentFileModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleComponentFileModal = (ids) => {
    this.setState({
      scannedFileIds: ids,
      isOpenMSF: true,
    });
  };

  closeModal() {
    this.setState({
      isOpenMSF: false,
    });
  }

  renderTreeTable(obj) {
    let totalCount = 0;
    for (let i = 0; i < Object.keys(obj).length; i++) {
      const arr = obj[Object.keys(obj)[i]];
      for (let j = 0; j < arr.length; j++) {
        totalCount++;
      }
    }

    return (
      Object.keys(obj).map((groupDetail, k) => {
        return (
          obj[groupDetail].map((file, l) => {
            return (
              <tr
                className=""
                key={`${file.component_name}_${file.component_version}_${file.scanned_file_name}`}
              >
                {
                  k === 0 && l === 0 ? (
                    <td className="tac border-bottom" rowSpan={totalCount}>
                      {file.component_name}
                    </td>
                  ) : null
                }
                {
                  l === 0 ? (
                    <td className="tac border-bottom" rowSpan={obj[groupDetail].length}>
                      {file.component_version}
                    </td>
                  ) : null
                }
                <td className="tac border-bottom has_link">
                  <span
                    onClick={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                    onKeyUp={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                  >
                    {file.scanned_file_name}
                  </span>
                </td>
              </tr>
            );
          })
        );
      })
    );
  }

  render() {
    const {
      rowData,
      uid,
      t,
      //location,
    } = this.props;

    const {
      isOpenMSF,
      scannedFileIds,
    } = this.state;

    //const pathname = location.pathname ? location.pathname : location;

    return Object.keys(rowData.cnvds).map((groupName) => {
      return (
        <table
          className="wide_card_table wide_card_item"
          key={groupName.toString()}
        >
          <colgroup>
            <col style={{ width: '33%' }} />
            <col style={{ width: '33%' }} />
            <col style={{ width: '33%' }} />
          </colgroup>
          <tbody>
            {this.renderTreeTable(rowData.cnvds[groupName])}
          </tbody>
          <ScannedFilesInfoModal
            isOpenMSF={isOpenMSF}
            closeModal={this.closeModal}
            ufid={uid}
            scannedFileIds={scannedFileIds}
            translate={t}
          />
        </table>
      );
    });
  }
}

export default withScrollbar(CNVDRow);
